// src/glossary.ts
var IS_PATCHED_MODULE = Symbol("isPatchedModule");

export {
  IS_PATCHED_MODULE
};
